export default "__VITE_ASSET__Cdcr1rlz__"